import React from "react";
import { Route } from "react-router-dom";

import { Home, About, Skills, Contact } from "./index";

export default function Navbar() {
  return (
    <>
      <Route exact path="/" component={Home} />
      {/* <Route exact path="/athar" component={Home} /> */}
      <Route path="/about" component={About} />
      <Route path="/skills" component={Skills} />
      <Route path="/contact" component={Contact} />
    </>
  );
}
